module.exports = __webpack_public_path__ + "static/img/frozen12.cfb37a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/frozen12.jpg
// module id = oLin
// module chunks = 0